"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Iterator_1 = require("./Iterator");
/**
 * Iterates over all the nodes in depth-first order, visiting the parent before its children.
 *
 * @param tree - The tree over which to iterate
 */
function preOrderTraversal(tree) {
    var stack = [];
    stack.push(tree);
    return {
        next: function () {
            var current = stack.pop();
            if (current === undefined) {
                return Iterator_1.iteratorResultDone;
            }
            for (var i = current.children.length - 1; i >= 0; i--) {
                stack.push(current.children[i]);
            }
            return Iterator_1.iteratorResultNotDone(current.node);
        }
    };
}
exports.preOrderTraversal = preOrderTraversal;
//# sourceMappingURL=RoseTreeIterators.js.map